<template>
  <div>
    <div
      v-if="!isValidSubscription"
      id="select-payment"
    >
      <div v-if="!isBrochure">
        <div v-if="!isTwoHoursBeforeStartTime">
          <div v-if="$auth.loggedIn && $auth.user.freeTrialVoucherCount > 0 && selectedSession.freeTrial">
            <t-button
              id="cart-btn"
              class="text-sm"
              :class="{ disabled: selectedSession.id.startsWith('CANC') || selectedSession.available <= 0 || isTwoHoursBeforeStartTime || checkItemSelected }"
              variant="ctaPrimary"
              :loading="loadingItem"
              @click="addToSubscription();"
            >
              Register for Free!
            </t-button>
          </div>
          <div v-else>
            <button
              id="cart-btn"
              class="text-lg bg-transparent font-bold text-accent-light ml-2"
              :class="{ disabled: selectedSession.id.startsWith('CANC') || selectedSession.available <= 0 || isTwoHoursBeforeStartTime || checkItemSelected }"
              variant="ctaPrimary"
              :loading="loadingItem"
              @click="addCartItem()"
            >
              Add to cart <t-icon
                name="chevron-right"
                class="ml-2 mt-1"
              />
            </button>
          </div>
        </div>
        <div v-else>
          <p class="font-bold">
            This course starts soon or has already started. If you'd like to register, please call Summit Customer Service at (800) 433-9570 to register.
          </p>
        </div>
      </div>
      <div v-else>
        <div v-if="$auth.loggedIn && $auth.user.freeTrialVoucherCount > 0 && selectedSession.freeTrial">
          <t-button
            v-if="btnState === 'addToCart'"
            id="cart-btn"
            class="text-sm"
            :class="{ disabled: selectedSession.id.startsWith('CANC') || selectedSession.available <= 0 || isTwoHoursBeforeStartTime || checkItemSelected }"
            variant="ctaPrimary"
            :loading="loadingItem"
            @click="addToSubscription();"
          >
            Register for Free!
          </t-button>
        </div>
        <div v-else>
          <button
            v-if="btnState === 'addToCart'"
            id="cart-btn"
            class="text-lg bg-transparent font-bold text-accent-light ml-2"
            :class="{ disabled: selectedSession.id.startsWith('CANC') || selectedSession.available <= 0 || isTwoHoursBeforeStartTime || checkItemSelected }"
            :loading="loadingItem"
            @click="addItemToCart();"
          >
            Add to cart <t-icon
              name="chevron-right"
              class="ml-2 mt-1"
            />
          </button>
          <button
            v-else-if="btnState === 'checkout'"
            class="text-lg bg-transparent font-bold text-accent-light ml-2"
            variant="ctaPrimary"
            :loading="loadingItem"
            @click="proceedToCheckout()"
          >
            Continue to checkout <t-icon
              name="chevron-right"
              class="ml-2 mt-1"
            />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NonSubscriberPaymentBtn',
  props: {
    isValidSubscription: {
      type: Boolean,
      default: false,

    },
    selectedSession: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,

    },
    redirectLoading: {
      type: Boolean,
      default: false,

    },
    selectedFormat: {
      type: String,
      required: true,
    },
    loadingItem: {
      type: Boolean,
      default: false,

    },
    isBrochure: {
      type: Boolean,
      default: false,

    },
    btnState: {
      type: String,
      default: '',
    },
    isIncludedInSubscription: {
      type: Boolean,
      default: false,

    },
    isTwoHoursBeforeStartTime: {
      type: Boolean,
      default: false,

    },
    checkItemSelected: {
      type: Boolean,
      default: false,

    },

  },
  methods: {
    addToSubscription() {
      this.$emit('add-to-subscription');
    },
    proceedToCheckout() {
      this.$emit('proceed-to-checkout');
    },
    addItemToCart() {
      this.$emit('add-item-to-cart');
    },
    addCartItem() {
      this.$emit('add-cart-item');
    },
    goToLive() {
      this.$emit('go-to-live');
    },
  },
};
</script>
